import React from 'react';
import { IconTrash } from './icons/StorefrontIcons';

/**
 * Icon-only remove control (cart page, cart drawer) — Tonoto-style.
 */
export default function LineItemRemoveButton({ label, onClick, className = '' }) {
  return (
    <button
      type="button"
      className={`line-item-remove-btn ${className}`.trim()}
      aria-label={label}
      title="Remove"
      onClick={onClick}
    >
      <IconTrash className="line-item-remove-btn__icon" width={18} height={18} />
    </button>
  );
}
